import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const [purpose, setPurpose] = useState("boost");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.purpose) setPurpose(r.data.purpose);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(r.data.status)) { setStatus("error"); return; }
      } catch { /* keep trying */ }
      if (attempts >= 10) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, []);

  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      {status === "checking" && (
        <>
          <Loader2 className="w-12 h-12 text-blaze animate-spin mx-auto" />
          <h1 className="font-heading font-900 text-2xl uppercase tracking-tight mt-6">Confirming Payment…</h1>
          <p className="text-sm text-muted-foreground mt-2">Hang tight, this only takes a moment.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle className="w-14 h-14 text-emerald-500 mx-auto" />
          <h1 className="font-heading font-900 text-3xl uppercase tracking-tight mt-6">{purpose === "dealer" ? "You're a Verified Dealer!" : "Listing Boosted!"}</h1>
          <p className="text-sm text-muted-foreground mt-2">{purpose === "dealer" ? "Your dealer badge is active and all your listings now get priority placement." : "Your listing now gets priority placement in search results."}</p>
          <Button data-testid="payment-dashboard-btn" onClick={() => navigate("/dashboard")} className="mt-6 bg-blaze hover:bg-blaze-hover text-white rounded-sm font-bold">Go to Dashboard</Button>
        </>
      )}
      {(status === "error" || status === "timeout") && (
        <>
          <XCircle className="w-14 h-14 text-destructive mx-auto" />
          <h1 className="font-heading font-900 text-2xl uppercase tracking-tight mt-6">{status === "timeout" ? "Still Processing" : "Payment Issue"}</h1>
          <p className="text-sm text-muted-foreground mt-2">{status === "timeout" ? "Your payment is taking longer than usual. Check your dashboard shortly." : "We couldn't confirm your payment."}</p>
          <Button onClick={() => navigate("/dashboard")} className="mt-6 bg-blaze hover:bg-blaze-hover text-white rounded-sm font-bold">Back to Dashboard</Button>
        </>
      )}
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      <XCircle className="w-14 h-14 text-muted-foreground mx-auto" />
      <h1 className="font-heading font-900 text-2xl uppercase tracking-tight mt-6">Payment Cancelled</h1>
      <p className="text-sm text-muted-foreground mt-2">No charge was made. You can boost your listing anytime.</p>
      <Button onClick={() => navigate("/dashboard")} className="mt-6 bg-blaze hover:bg-blaze-hover text-white rounded-sm font-bold">Back to Dashboard</Button>
    </div>
  );
}
